import React from 'react'
import { Link } from 'react-router-dom'
import './css/Footer.css'
import me2 from './images/me2.jpg'
import { BsFacebook, BsInstagram, BsLinkedin } from 'react-icons/bs'
import { ImTwitter, ImGithub } from 'react-icons/im'

function Footer() {
  return (
    <div>

        <section id="footer">
            <div className="container">
                <footer>
                    <div className="col-1">
                        <div className="logo">
                            <Link className='link'>
                                <img src={me2} alt="" />
                            </Link>
                        </div>
                        <p>
                            A Student from kolkata, India. Still learning.
                        </p>
                    </div>
                    <div className="col-2">
                        <h2 className="column-heading">Contact<br/>Info</h2>
                        <ul>
                            <li><a href="mailto:subhadipmandal688@gmail.com" className='link'>subhadipmandal688@gmail.com</a></li>
                            <li><a href="tel:+917044716893" className='link'>+917044716893</a></li>
                            <li><Link className='link'>Kolkata, India</Link></li>
                        </ul>
                    </div>
                    <div className="col-3">
                        <h2 className="column-heading">Social<br/>Links</h2>
                        <ul>
                            <li><a href="https://www.facebook.com/subhadip.mandal.75457081"><BsFacebook/></a></li>
                            <li><a href="https://twitter.com/Subhadip_321?t=lhXilxuKPMwDwkCPkyHdaQ&s=09"><ImTwitter/></a></li>
                            <li><a href="https://www.instagram.com/_subhadip.mandal"><BsInstagram/></a></li>
                            <li><a href="https://www.linkedin.com/in/subhadip-mandal-a49917215"><BsLinkedin/></a></li>
                            <li><a href="https://github.com/subhadip000"><ImGithub/></a></li>
                        </ul>
                    </div>
                </footer>
            </div>
        </section>
        <section id="copyright">
            <div className="container">
                <p> &copy; Copyright 2022 Subhadip. All right Reserved</p>
            </div>
        </section>

    </div>
  )
}

export default Footer